<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li><router-link to="/products">Products</router-link></li>
        <li><router-link v-bind:to="`/products/${this.$route.params.product_id}`">{{ this.$store.state.product.name }}</router-link></li>
        <li><router-link v-bind:to="`/products/${this.$route.params.product_id}/things`">Smart things</router-link></li>
        <li class="is-active"><a href="#" aria-current="page">{{ this.$store.state.thing.name || 'No name' }}</a></li>
      </ul>
    </nav>

    <modal v-bind:visible="showModal" v-on:close="closeDeleteThingModal">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="title is-4">Deleting smart thing</p>
        </header>
        <section class="modal-card-body">
          <div class="media">
            <div class="media-left">
              <span class="icon is-large has-text-danger"><i class="fa fa-3x fa-exclamation-triangle"></i></span>
            </div>
            <div class="media-content">
              <p>Are you sure you want to <strong>delete</strong> this smart thing?</p>
              <p>This action cannot be undone.</p>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-danger" v-on:click="deleteItem">Delete</button>
          <button class="button is-light" v-on:click="closeDeleteThingModal">Cancel</button>
        </footer>
      </div>
    </modal>

    <div class="columns">
      <div class="column is-8 is-offset-1">
        <p class="title is-4">{{ this.$store.state.thing.name || 'No name' }}</p>
        <p><span class="has-text-grey">Smart thing ID:</span> {{ $route.params.thing_id }}</p>
        <p><span class="has-text-grey">Identifier:</span> {{ this.$store.state.thing.identifier }}</p>
        <p><span class="has-text-grey">Product name:</span> {{ this.$store.state.product.name }}</p>
        <p><span class="has-text-grey">Created at:</span> {{ this.$store.state.thing.created_at }}</p>
        <p><span class="has-text-grey">Updated at:</span> {{ this.$store.state.thing.updated_at }}</p>
        <!--<p><span class="has-text-grey">Firmware version:</span> {{ this.$store.state.thing.states.items[0].value }}</p>-->
        <!--<p v-if="this.$store.state.thing.states.items[0].value != 1"><span class="has-text-grey">Firmware version:</span>{{ this.$store.state.thing.states.items[0].value }}</p>-->
        <p><span class="has-text-grey">Firmware version:</span>{{ this.$store.state.states.length ? this.$store.state.thing.states.items[0].value : ' 0.0.0' }}</p>
        <p><span class="has-text-grey">Latest online time:</span> {{ this.$store.state.states.length ? this.$store.state.states[0].updated_at : 'Unknown' }}</p>
      </div>

      <div class="column is-2">
        <div class="field is-grouped">
          <div class="control">
            <router-link v-bind:to="`/products/${this.$route.params.product_id}/things/${this.$route.params.thing_id}/edit`" class="button is-primary is-outlined">
              <span class="icon"><i class="fa fa-lg fa-pencil"></i></span>
              <span>Edit</span>
            </router-link>
          </div>
          <div class="control">
            <a v-on:click="openDeleteThingModal" class="button is-danger is-outlined">
              <span class="icon"><i class="fa fa-lg fa-trash"></i></span>
              <span>Delete</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <hr>

    <div class="columns">
      <div class="column is-10 is-offset-1">
        <h5 class="subtitle is-5 has-text-centered has-text-blue-gray">Users</h5>
        <table class="table is-striped is-fullwidth">
          <thead>
            <tr>
              <th>ID</th>
              <th>Role</th>
              <th>Name</th>
              <th>Email</th>
              <th>Created at</th>
              <th>Updated at</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!this.$store.state.owners.length && !this.$store.state.guests.length && !this.$store.state.invitees.length">
              <td colspan="6" class="has-text-centered has-text-grey">No users found</td>
            </tr>
            <tr v-for="item in this.$store.state.owners">
              <td>{{ item.id }}</td>
              <td><span class="tag badge-owner">owner</span></td>
              <td><router-link v-bind:to="`/users/${item.id}`">{{ item.name }}</router-link></td>
              <td>{{ item.email }}</td>
              <td>{{ item.created_at }}</td>
              <td>{{ item.updated_at }}</td>
            </tr>
            <tr v-for="item in this.$store.state.guests">
              <td>{{ item.id }}</td>
              <td><span class="tag badge-guest">guest</span></td>
              <td><router-link v-bind:to="`/users/${item.id}`">{{ item.name }}</router-link></td>
              <td>{{ item.email }}</td>
              <td>{{ item.created_at }}</td>
              <td>{{ item.updated_at }}</td>
            </tr>
            <tr v-for="item in this.$store.state.invitees">
              <td>{{ item.id }}</td>
              <td><span class="tag badge-invitee">invitee</span></td>
              <td><router-link v-bind:to="`/users/${item.id}`">{{ item.name }}</router-link></td>
              <td>{{ item.email }}</td>
              <td>{{ item.created_at }}</td>
              <td>{{ item.updated_at }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import { Modal } from 'vue-bulma-modal'

  export default {
    data () {
      return {
        showModal: false
      }
    },

    methods: {
      deleteItem () {
        this.showModal = false
        this.$store.dispatch('deleteThing', this.$route.params.thing_id)
          .then(() => {
            this.$router.push(`/products/${this.$route.params.product_id}/things`)
          })
          .catch(() => {
            // Simply don't redirect user anywhere
            this.$store.commit('SHOW_ERROR_BUBBLE', true)
          })
      },

      openDeleteThingModal () {
        this.showModal = true
      },

      closeDeleteThingModal () {
        this.showModal = false
      }
    },

    created () {
      this.$store.dispatch('getProduct', {
        productId: this.$route.params.product_id
      })

      this.$store.dispatch('getThing', {
        thingId: this.$route.params.thing_id,
        params: {
          include: 'owners,guests,invitees,states:sort(created_at):order(desc):limit(1)'
        }
      })
    },

    components: {
      Modal
    }
  }
</script>

<style>
  .modal-card-foot{
    justify-content: flex-end;
  }

  .tag.badge-owner {
    background-color: #FFA726;
    color: #fff;
  }

  .tag.badge-guest {
    background-color: #388E3C;
    color: #fff;
  }

  .tag.badge-invitee {
    background-color: #039BE5;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// ThingView.vue?f409d856